import React, { useState } from 'react';
import { Facebook, Twitter, MessageCircle, MessageSquare, Mail, Link2, Check } from 'lucide-react';

export const ShareButtons = ({ url, title }) => {
  const [copied, setCopied] = useState(false);
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);
  const text = encodeURIComponent(`${title} — ${url}`);

  const links = [
    { id: 'facebook', label: 'Facebook', Icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}` },
    { id: 'x', label: 'X', Icon: Twitter, href: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}` },
    { id: 'whatsapp', label: 'WhatsApp', Icon: MessageCircle, href: `https://wa.me/?text=${text}` },
    { id: 'sms', label: 'Text', Icon: MessageSquare, href: `sms:?&body=${text}` },
    { id: 'email', label: 'Email', Icon: Mail, href: `mailto:?subject=${encodedTitle}&body=${text}` },
  ];

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const ta = document.createElement('textarea');
      ta.value = url;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const btnCls = 'inline-flex items-center gap-2 rounded-full border border-[#DCD3C3] bg-white px-4 py-2 text-[14px] text-[#3D5142] hover:border-[#3D5142] hover:text-[#C4715A] transition-colors';

  return (
    <div data-testid="share-buttons" className="flex flex-wrap items-center gap-3">
      <span className="text-[14px] font-medium text-[#5A554C] mr-1">Share this guide:</span>
      {links.map(({ id, label, Icon, href }) => (
        <a key={id} href={href} target={id === 'sms' || id === 'email' ? undefined : '_blank'} rel="noopener noreferrer" data-testid={`share-${id}-btn`} className={btnCls} aria-label={`Share via ${label}`}>
          <Icon className="w-4 h-4 text-[#C4715A]" /> {label}
        </a>
      ))}
      <button type="button" onClick={copyLink} data-testid="share-copy-btn" className={btnCls} aria-label="Copy link">
        {copied ? <Check className="w-4 h-4 text-[#3D5142]" /> : <Link2 className="w-4 h-4 text-[#C4715A]" />} {copied ? 'Copied!' : 'Copy link'}
      </button>
    </div>
  );
};

export default ShareButtons;
